import * as React from 'react';
import type { YMaps } from '@cian/frontend-ymaps-components/es/types/ymaps';

const POLL_INTERVAL = 150;

export interface IMapZoomWatcherProps {
  mapRef: React.RefObject<YMaps.YMap | null>;
  onZoomChange(zoom: number): void;
}

export function MapZoomWatcher({ mapRef, onZoomChange }: IMapZoomWatcherProps): null {
  React.useEffect(() => {
    const intervalId = window.setInterval(() => {
      const map = mapRef.current;

      if (map) {
        onZoomChange(map.zoom);
      }
    }, POLL_INTERVAL);

    return () => window.clearInterval(intervalId);
  }, [mapRef, onZoomChange]);

  return null;
}
